










import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { TagInfo } from "@teacherskaya/api-provider/dist/api/TagsProvider";
import { CheckAuthorities } from "@/lib/helpers/componentViewController/decorators";

@Component({
  name: "BlockTagItem",
})
export default class BlockTagItem extends Vue {
  @Prop({ type: Object, required: true })
  public readonly tag!: TagInfo;

  @CheckAuthorities("BlockUserTags", "set_any")
  public allowUpdate!: boolean;

  public edit() {
    return this.$emit("edit", this.tag);
  }
}
